<template>
  <section class="page--section">
    <h2 class="section__title">{{ $t('trainingUpcomingWebinars') }}</h2>
    <ul class="webinar__list">
      <li class="webinar__list-item" v-for="webinar in webinars" :key="webinar.id">
        <el-row :gutter="30" type="flex" align="middle">
          <el-col :sm="4">
            <span class="webinar__date font-family-headings">{{ moment(webinar.eventDate).format('D') }}</span>
            <span class="webinar__month">{{ moment(webinar.eventDate).format('MMMM') }}</span>
          </el-col>
          <el-col :sm="4" class="text-align-right">
            <span class="webinar__title">{{ webinar.title }}</span>
            <a :href="webinar.registrationLinkUrl" class="webinar__link">{{ webinar.registrationLinkTitle }}</a>
          </el-col>
        </el-row>
      </li>
    </ul>
  </section>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TrainingWebinarListing',
  props: [
    'webinars',
  ],
  methods: {
    moment,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.webinar {

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__list-item {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: none;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  &__date,
  &__month,
  &__title,
  &__link {
    display: block;
  }

  &__date {
    font-size: 24px;
    font-weight: 900;
    line-height: 24px;
  }

  &__month {
    font-size: 12px;
    text-transform: uppercase;
  }

  &__title {
    font-size: 16px;
  }

  &__link {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: $--serif-letter-spacing;
  }
}
</style>
